let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("7dNJ4")]).then(() => parcelRequire('9rMVR'));